import {
  AfterViewInit,
  ChangeDetectorRef,
  NgZone,
  Component,
  ElementRef,
  HostListener,
  OnDestroy,
  OnInit,
  Renderer2,
  ViewChild
} from '@angular/core';
import {first} from 'rxjs/operators';
import swal from "sweetalert2";
import {FormBuilder} from '@angular/forms';
import {AuthService} from '../auth/AuthService';
import {Router} from '@angular/router';
import {DatePipe} from '@angular/common';
import {ReportService} from '../Services/report.service';
import * as Chart from 'chart.js';
import {StatsService} from "../Services/stats.service";
import {UserService} from "../Services/UserService";
import {animate, style, transition, trigger} from '@angular/animations';
import {RcmChatService, ChatMessage} from "../Services/rcm-chat.service";
import {ClientIdBusService} from "../Services/client-id-bus.service";
import {Subscription, timer} from "rxjs";
import { PageEvent } from '@angular/material/paginator';
import { PatientService } from '../Services/patient.service';
import { jwtDecode } from 'jwt-decode';

type Role = 'user' | 'ai' | 'system';

interface Message {
  id: string;
  role: Role;
  text: string;
  ts: Date;
}
interface VerificationStatusData {
  count: number;
  formTypes?: {
    [key: string]: number;
  };
}
interface AverageCompletionTimeData {
  averageSeconds: number;
  averageFormatted: string;
}
interface ProviderDashboardSummary {
  totalRequests: number;
  assigned: number;
  verified: number;
  notVerified: number;
  inProgress: number;
}
interface ProviderPatientRow {
  id: number;
  firstName: string;
  lastName?: string;
  dob: string;
  patientId: string;
  formType: string;
  insuranceType: string;
  payerName: string;
  careerName: string;
  insuranceId: string;
  memberId: string;
  subscriberDob: string;
  insurancePhone: string;
  apptDate: string;
  apptTime: string;
  providerName: string;
  office: string;
  groupNo: string;
  formFillTime: string;
}

interface VolumeTrendPoint {
  date: string;
  totalCount: number;
  pending: number;
  verified: number;
  backlog: number;
  notVerified: number;
  assigned: number;
  unassigned: number;
}

interface ExtractionVolumeTrendPoint {
  date: string;
  totalCount: number;
  successCount: number;
  failedCount: number;
}

interface ExtractionPatientRow {
  id: number;
  firstName: string;
  lastName: string;
  dateOfBirth: string;
  memberId: string;
  clientId: number;
  officeId: number;
  source: string;
  status: string;
  createdAt: string;
}

interface TrendSeries {
  label: string;
  key: keyof VolumeTrendPoint;
  color: string;
} 
interface AdminAgentPresence {
  userName: string;
  firstName: string;
  lastName: string;
  userId: string;
  keycloakUserId?: string;

  online: boolean;
  lastSeenAt?: string | null;
  activeSessionCount: number;

  totalCount?: number;

  verificationStatus?: {
    PENDING?: VerificationStatusData;
    VERIFIED?: VerificationStatusData;
    BACKLOG?: VerificationStatusData;
    NOT_VERIFIED?: VerificationStatusData;
  };

  averageCompletionTime?: {
    'ELIG CHECK'?: AverageCompletionTimeData;
    'SHORT FORM'?: AverageCompletionTimeData;
    'FULL FORM'?: AverageCompletionTimeData;
  };
}
interface AdminClientPresence {
  clientId: number;
  clientName: string;
  users: AdminAgentPresence[];

  overallData: {
    totalUsers: number;
    onlineUsers: number;
    offlineUsers: number;

    overallStatus?: {
      PENDING?: VerificationStatusData;
      VERIFIED?: VerificationStatusData;
      BACKLOG?: VerificationStatusData;
      NOT_VERIFIED?: VerificationStatusData;
      ASSIGNED?: VerificationStatusData;
      UNASSIGNED?: VerificationStatusData;
    };

    overallAverageCompletionTime?: {
      'ELIG CHECK'?: AverageCompletionTimeData;
      'SHORT FORM'?: AverageCompletionTimeData;
      'FULL FORM'?: AverageCompletionTimeData;
    };

    totalOverallCount?: number;
  };
}
interface AdminPresenceResponse {
  clients: AdminClientPresence[];
  providerStatus?: ProviderOfficeGroup[];

  volumeTrend?: VolumeTrendPoint[];

  overallData?: {
    overallStatus?: any;
    volumeTrend?: VolumeTrendPoint[];
    [key: string]: any;
  };
}
// interface ProviderOfficeStatus {
//   officeId: number;
//   officeName: string;

//   verificationStatus?: {
//     PENDING?: VerificationStatusData;
//     VERIFIED?: VerificationStatusData;
//     BACKLOG?: VerificationStatusData;
//     NOT_VERIFIED?: VerificationStatusData;
//   };

//   totalCount?: number;
// }

interface ProviderStatus {
  userName: string;
  firstName: string;
  lastName: string;
  userId: string;
  keycloakUserId?: string | null;

  online: boolean | null;
  lastSeenAt?: string | null;
  activeSessionCount?: number;

  verificationStatus?: {
    PENDING?: VerificationStatusData;
    VERIFIED?: VerificationStatusData;
    BACKLOG?: VerificationStatusData;
    NOT_VERIFIED?: VerificationStatusData;
  };

  averageCompletionTime?: {
    'ELIG CHECK'?: AverageCompletionTimeData;
    'SHORT FORM'?: AverageCompletionTimeData;
    'FULL FORM'?: AverageCompletionTimeData;
  };

  totalCount: number;
}
interface ProviderOfficeGroup {
  officeId: number;
  officeName: string;
  providers: ProviderStatus[];
  totalCount: number;
}
// interface ProviderOfficeRow {
//   providerUserId: string;
//   keycloakUserId?: string | null;
//   userName: string;
//   firstName: string;
//   lastName: string;
//   online: boolean | null;

//   officeId: number | null;
//   officeName: string;

//   verificationStatus?: {
//     PENDING?: VerificationStatusData;
//     VERIFIED?: VerificationStatusData;
//     BACKLOG?: VerificationStatusData;
//     NOT_VERIFIED?: VerificationStatusData;
//   };

//   totalCount: number;
// }

type ExtractionClientScope = 'SINGLE' | 'ALL';
type ExtractionStatus = 'ALL' | 'SUCCESS' | 'FAILED';
@Component({
    templateUrl: './homeComponent.html',
    styleUrls: [
    './homeComponent.css'
    ],
    animations: [
      trigger('fadeInOut', [
        transition(':enter', [
          style({ opacity: 0 }),
          animate('400ms ease-in', style({ opacity: 1 }))
        ]),
        transition(':leave', [
          animate('400ms ease-out', style({ opacity: 0 }))
        ])
      ])
    ]
})

export class HomeComponent implements OnInit,OnDestroy,AfterViewInit {

    isExternalUser = false;
    isExternalAdminOrSupervisor = false;
    canEditProviderPatients = false;
    providerSummary: ProviderDashboardSummary = {
      totalRequests: 0,
      assigned: 0,
      verified: 0,
      notVerified: 0,
      inProgress: 0
    };
    providerPatients: ProviderPatientRow[] = [];
    providerPagination = {
      page: 0,
      size: 10
    };
    providerTotalRecords = 0;
    providerTableLoading = false;
    providerPageSizeOptions: number[] = [5, 10, 20, 50];
    agentsTableData: any = [];
    agentSearchTerm: string = '';
    showAgentSearch: boolean = false;
    isDarkMode = false;
    providerTrendLoading = false;
    providerTrendError = false;
    providerTrendChart: any = null;
    providerTrendData: VolumeTrendPoint [] = [];
    extractionVolumeTrend: ExtractionVolumeTrendPoint[] = [];
    private pollSub?: Subscription;
    private busSub?: Subscription;
    private providerPatientsSub?: Subscription;
    pollingInterval: ReturnType<typeof setInterval> | null = null;
    overallStatus:any;
    totalCount:number = 0;
    totalPending:number = 0;
    totalUnAssigned:number = 0;
    totalVerified:number = 0;
    totalBacklog:number = 0;
    intervalId: any;
    totalNotVerified = 0; // assigned
    totalAssigned:number = 0;
    /*chartType:any = 'doughnut';*/
    chart1Type: string = 'line'; // default for card 1
    chart2Type: string = 'line';      // default for card 2
    chart3Type: string = 'radar';
    /*chart: any = null; // Store Chart Instance*/
    chart1: any = null;
    chart2: any = null;
    chart3: any = null;
    startDate: Date = new Date();
    endDate: Date = new Date();
    todaysDate: Date = new Date();
    selectedTimezone: string = '';
    verificationTimeChart: any = null;
    topAgentsByAvgTime: any[] = [];
    adminClients: AdminClientPresence[] = [];
    onlineUsersCount = 0;
    offlineUsersCount = 0;
    totalUniqueUsersCount = 0;
    isAdminPresenceLoading = false;
    adminPresenceError = false;
    providerOfficeGroups: ProviderOfficeGroup[] = [];
    showOnlineUsersPanel = false;
    showExtractionFilters = false;
    insuranceDropdownActive = false;

extractionClientScope: ExtractionClientScope = 'SINGLE';
private jwtClientIds: string[] = [];

extractionStatuses: ExtractionStatus[] = [
  'ALL',
  'SUCCESS',
  'FAILED'
];

selectedExtractionStatus: ExtractionStatus = 'ALL';

extractionSources: string[] = [
  'CIGNA',
  'METLIFE',
  'DELTA_DENTAL_INS',
  'DELTA_DENTAL_INS_SHORTFORM',
  'DENTAL_TOOLKIT',
  'dentalxchange',
  'LIBERTY_DENTAL',
  'SCION',
  'MEDICAID',
  'DENTICON',
  'DHCS',
  'DENTAQUEST'
];

selectedExtractionSources: string[] = [
  'CIGNA',
  'METLIFE',
  'DELTA_DENTAL_INS',
  'DELTA_DENTAL_INS_SHORTFORM',
  'DENTAL_TOOLKIT',
  'dentalxchange',
  'LIBERTY_DENTAL',
  'SCION',
  'MEDICAID',
  'DENTICON',
  'DHCS',
  'DENTAQUEST'
];

extractionTotalCount = 0;
extractionSuccessCount = 0;
extractionFailedCount = 0;

isExtractionMetricsLoading = false;
private extractionMetricsRequestId = 0;
extractionDrilldownStatus: 'SUCCESS' | 'FAILED' | null = null;
extractionPatients: ExtractionPatientRow[] = [];
extractionDrilldownLoading = false;
extractionDrilldownError = false;
private extractionDrilldownCache: { [key: string]: ExtractionPatientRow[] } = {};
    timezones: string[] = [
      'UTC',

      // -------------------------
      // UNITED STATES
      // -------------------------
      'America/New_York',       // Eastern
      'America/Chicago',        // Central
      'America/Denver',         // Mountain
      'America/Phoenix',        // Arizona - no DST
      'America/Los_Angeles',    // Pacific
      'America/Anchorage',      // Alaska
      'America/Adak',           // Aleutian Islands
      'Pacific/Honolulu',       // Hawaii

      // -------------------------
      // CANADA
      // -------------------------
      'America/St_Johns',       // Newfoundland
      'America/Halifax',        // Atlantic
      'America/Moncton',        // Atlantic
      'America/Glace_Bay',      // Atlantic
      'America/Goose_Bay',      // Atlantic
      'America/Toronto',        // Eastern
      'America/Iqaluit',        // Eastern
      'America/Winnipeg',       // Central
      'America/Regina',         // Saskatchewan - no DST
      'America/Swift_Current',  // Saskatchewan - no DST
      'America/Edmonton',       // Mountain
      'America/Cambridge_Bay',  // Mountain
      'America/Inuvik',         // Mountain
      'America/Dawson_Creek',   // MST / no DST
      'America/Fort_Nelson',    // MST / no DST
      'America/Vancouver',      // Pacific
      'America/Whitehorse',     // Yukon
      'America/Dawson',         // Yukon

      // -------------------------
      // OTHER AMERICAS
      // -------------------------
      'America/Argentina/Buenos_Aires',
      'America/Mexico_City',
      'America/Sao_Paulo',

      // -------------------------
      // ASIA
      // -------------------------
      'Asia/Almaty',
      'Asia/Baghdad',
      'Asia/Baku',
      'Asia/Bangkok',
      'Asia/Beirut',
      'Asia/Colombo',
      'Asia/Dhaka',
      'Asia/Dubai',
      'Asia/Hong_Kong',
      'Asia/Jakarta',
      'Asia/Jerusalem',
      'Asia/Kabul',
      'Asia/Karachi',
      'Asia/Kathmandu',
      'Asia/Kolkata',
      'Asia/Kuala_Lumpur',
      'Asia/Magadan',
      'Asia/Manila',
      'Asia/Muscat',
      'Asia/Novosibirsk',
      'Asia/Seoul',
      'Asia/Shanghai',
      'Asia/Singapore',
      'Asia/Tashkent',
      'Asia/Tehran',
      'Asia/Tokyo',
      'Asia/Vladivostok',
      'Asia/Yekaterinburg',
      'Asia/Yerevan',

      // -------------------------
      // PACIFIC
      // -------------------------
      'Pacific/Apia',
      'Pacific/Auckland',
      'Pacific/Bougainville',
      'Pacific/Chatham',
      'Pacific/Chuuk',
      'Pacific/Easter',
      'Pacific/Efate',
      'Pacific/Fakaofo',
      'Pacific/Fiji',
      'Pacific/Funafuti',
      'Pacific/Galapagos',
      'Pacific/Gambier',
      'Pacific/Guadalcanal',
      'Pacific/Guam',
      'Pacific/Honolulu',
      'Pacific/Kanton',
      'Pacific/Kiritimati',
      'Pacific/Kosrae',
      'Pacific/Kwajalein',
      'Pacific/Majuro',
      'Pacific/Marquesas',
      'Pacific/Midway',
      'Pacific/Nauru',
      'Pacific/Niue',
      'Pacific/Norfolk',
      'Pacific/Noumea',
      'Pacific/Pago_Pago',
      'Pacific/Palau',
      'Pacific/Pitcairn',
      'Pacific/Pohnpei',
      'Pacific/Port_Moresby',
      'Pacific/Rarotonga',
      'Pacific/Saipan',
      'Pacific/Tahiti',
      'Pacific/Tarawa',
      'Pacific/Tongatapu',
      'Pacific/Wake',
      'Pacific/Wallis'
    ];
    overallAverageCompletionTime: any = {};
    verificationTimeSummary: any[] = [];
    overallAvgTimeMinutes = 0;
    overallAvgTimeFormatted = '0 min';
    showAgentsTable: boolean = true;
    projectsTableData: any [] = [];
    showNavratri = false;
    selectedPlanType: 'PPO' | 'HMO' =
      (localStorage.getItem('dashboardPlanType') as 'PPO' | 'HMO') || 'PPO';
    isLoading = false;
    @ViewChild('scrollContainer') scrollContainer!: ElementRef<HTMLDivElement>;


    input = '';
    isTyping = false;
    suggestions = [
      'Claim Submission',
      'Eligibility & Benefits',
      'Coding Guidelines',
      'Denial Management',
      'AR Follow‑up'
    ];


    messages: Message[] = [
      {
        id: this.uid(),
        role: 'ai',
        text: 'Hi! I\'m your Dental RCM Assistant. Ask about claims, denials, coding, or AR.',
        ts: new Date()
      }
    ];
    isOpen = false;

  constructor(private fb: FormBuilder,
                private reportsService: ReportService,
                private ngZone: NgZone,
                private cdr: ChangeDetectorRef,
                public authService: AuthService,
                private datePipe: DatePipe,
                private statsService: StatsService,
                private userService: UserService,
                private patientService: PatientService,
                private chatApi: RcmChatService,
                private clientBus: ClientIdBusService
    ) {
    }

    private get todayKey(): string {
      const d = new Date();
      const y = d.getFullYear();
      const m = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      return `navratri_greeting_seen_${y}${m}${day}`;
    }

    async ngOnInit(): Promise<void> {
        this.isExternalUser = this.authService.isExternalUser();
        await this.initializeExternalGroupAccess();

        if (!this.isExternalUser) {
          await this.initializeJwtClientIds();
        }

        // Load saved theme preference from localStorage
        const savedTheme = localStorage.getItem('theme');
        this.isDarkMode = savedTheme === 'dark';
        this.applyTheme();

        const savedTimeZone = this.authService.getTimeZone();
        if (savedTimeZone) {
          this.selectedTimezone = savedTimeZone;
        }

      // Initial load if client already exists
        const existing = this.readClientIdSafely();
        if (this.isExternalUser) {
          this.loadProviderDashboard();
        } else if (existing) {
          this.startPolling();
        }

        this.busSub = this.clientBus.selectedClientId$.subscribe((clientId) => {
          if (!clientId) {
            return;
          }

          if (this.isExternalUser) {
            this.providerPagination.page = 0;
            this.loadProviderDashboard();
            return;
          }

          this.stopPolling();
          this.startPolling();
        });
    }

    ngAfterViewInit() {
      if (this.isExternalUser) {
        return;
      }

      setTimeout(() => {
          this.createChart(
            'chart2Canvas',
            this.chart2Type
          );

          this.createChart(
            'chart3Canvas',
            this.chart3Type
          );

        }, 0);
    }

    @HostListener('document:click', ['$event'])
    closeExtractionFilters(event: MouseEvent): void {
      if (this.insuranceDropdownActive) {
        return;
      }

      const target = event.target as HTMLElement;

      if (target.closest('.extraction-filter-wrap')) {
        return;
      }

      if (target.closest('.extraction-insurance-panel')) {
        return;
      }

      this.showExtractionFilters = false;
    }

    toggleTable(isAgent: boolean) {
      this.showAgentsTable = isAgent;
    }

  send(text?: string) {
    const value = (text ?? this.input).trim();
    if (!value) return;


// Push user message
    this.messages.push({ id: this.uid(), role: 'user', text: value, ts: new Date() });
    this.input = '';
    this.smoothScrollToBottom();


// Simulate AI typing + response
    this.isTyping = true;
    // const aiText = this.mockAiResponse(value);


    // setTimeout(() => {
    //   this.messages.push({ id: this.uid(), role: 'ai', text: aiText, ts: new Date() });
    //   this.isTyping = false;
    //   this.smoothScrollToBottom();
    // }, 900);

    // Real API
    /*this.messages.push({ id: this.uid(), role: 'user', text: value, ts: new Date() });
    this.input = '';
    this.isTyping = true;

    const history: ChatMessage[] = [
      { role: 'system', content: 'You are a helpful Dental RCM assistant.' },
      // map your local message list to {role, content}
      ...this.messages.map(m => ({
        role: m.role === 'ai' ? 'assistant' : (m.role as 'user' | 'assistant' | 'system'),
        content: m.text
      }))
    ];

    this.chatApi.send(history).subscribe({
      next: (resp) => {
        this.messages.push({ id: this.uid(), role: 'ai', text: resp.text, ts: new Date() });
        this.isTyping = false;
        this.smoothScrollToBottom();
      },
      error: (err) => {
        this.messages.push({ id: this.uid(), role: 'ai', text: 'Error: ' + (err?.error || 'API failed'), ts: new Date() });
        this.isTyping = false;
      }
    });*/
  }

  onKeydown(e: KeyboardEvent) {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      this.send();
    }
  }

  pickSuggestion(s: string) {
    this.send(s);
  }

// --- Helpers ---
  private uid() {
    return Math.random().toString(36).slice(2);
  }

//   private mockAiResponse(userText: string): string {
// // Lightweight heuristics for demo purposes only
//     const t = userText.toLowerCase();
//     if (t.includes('claim') && t.includes('submit')) {
//       return 'For claim submission: (1) Verify eligibility, (2) Use correct CDT codes, (3) Attach X‑rays if required, (4) Submit within payer timely filing limits, (5) Track status in 7–10 days.';
//     }
//     if (t.includes('denial')) {
//       return 'Common denial reasons: missing documentation, incorrect coding/modifiers, eligibility issues, and timely filing. Start with EOB code → correct & resubmit or appeal within the window.';
//     }
//     if (t.includes('coding')) {
//       return 'Follow CDT coding guidelines; ensure narrative supports medical necessity. Crosswalk with payer policies and watch for frequency limitations.';
//     }
//   }

  private smoothScrollToBottom() {
    setTimeout(() => {
      if (!this.scrollContainer) return;
      const el = this.scrollContainer.nativeElement;
      el.scrollTo({ top: el.scrollHeight, behavior: 'smooth' });
    });
  }


    getFormTypesTooltip(formTypes: any): string {
        if (!formTypes || Object.keys(formTypes).length === 0) {
            return 'No form type details available';
        }

        // Create multiline tooltip text
        return Object.entries(formTypes)
          .map(([name, count]) => `• ${name}: ${count}`)
            .join('\n');
    }



  togglePanel() { this.isOpen = !this.isOpen; }
  closePanel()  { this.isOpen = false; }

  createChart(chartId: string, chartType: string) {
    const ctx = document.getElementById(chartId) as HTMLCanvasElement | null;
    if (!ctx) {
      return;
    }

    const canvasCtx = ctx.getContext('2d');
    if (!canvasCtx) {
      return;
    }

    const isDarkMode = this.isDarkMode;

    if (chartId === 'chart1Canvas' && this.chart1) {
      this.chart1.destroy();
    }
    if (chartId === 'chart2Canvas' && this.chart2) {
      this.chart2.destroy();
    }
    if (chartId === 'chart3Canvas' && this.chart3) {
      this.chart3.destroy();
    }

    let labels: string[];
let chartData: number[];
let lightPalette: string[];
let darkPalette: string[];

if (chartId === 'chart1Canvas') {

  labels = [
    'Total',
    'Successful',
    'Not Found'
  ];

  chartData = [
    this.extractionTotalCount,
    this.extractionSuccessCount,
    this.extractionFailedCount
  ];

  lightPalette = [
    '#99c4ea',
    '#9ad9b1',
    '#ecafa6'
  ];

  darkPalette = [
    '#60a5fa',
    '#4ade80',
    '#f87171'
  ];

} else {

  labels = [
    'Total',
    'Un-Assigned',
    'Assigned',
    'Verified',
    'Not-Verified',
    'Pending',
    'Backlog'
  ];

  chartData = [
    this.totalCount,
    this.totalUnAssigned,
    this.totalAssigned,
    this.totalVerified,
    this.totalNotVerified,
    this.totalPending,
    this.totalBacklog
  ];

  lightPalette = [
    '#efd468',
    '#f3c7c7',
    '#99c4ea',
    '#9ad9b1',
    '#b79be0',
    '#f0c794',
    '#ecafa6'
  ];

  darkPalette = [
    '#f4d35e',
    '#d88c9a',
    '#60a5fa',
    '#4ade80',
    '#a78bfa',
    '#fbbf24',
    '#f87171'
  ];
}

    const palette = isDarkMode ? darkPalette : lightPalette;

    const textColor = isDarkMode ? '#e5e7eb' : '#334155';
    const gridColor = isDarkMode ? 'rgba(255,255,255,0.08)' : 'rgba(51,65,85,0.10)';
    const legendColor = isDarkMode ? '#e5e7eb' : '#475569';
    const borderColor = isDarkMode ? '#111827' : '#ffffff';

    let datasetConfig: any = {
      data: chartData,
      backgroundColor: palette,
      borderColor: palette.map(() => borderColor),
      borderWidth: 1.5,
      hoverOffset: 8
    };

    if (chartType === 'line') {
      const gradient = canvasCtx.createLinearGradient(0, 0, 0, ctx.height);
      if (isDarkMode) {
        gradient.addColorStop(0, 'rgba(96, 165, 250, 0.45)');
        gradient.addColorStop(1, 'rgba(96, 165, 250, 0.03)');
      } else {
        gradient.addColorStop(0, 'rgba(59, 130, 246, 0.35)');
        gradient.addColorStop(1, 'rgba(59, 130, 246, 0.04)');
      }

      datasetConfig = {
        label: 'Counts',
        data: chartData,
        borderColor: isDarkMode ? '#60a5fa' : '#2563eb',
        backgroundColor: gradient,
        borderWidth: 3,
        fill: true,
        tension: 0.38,
        pointBackgroundColor: isDarkMode ? '#0f172a' : '#ffffff',
        pointBorderColor: isDarkMode ? '#60a5fa' : '#2563eb',
        pointRadius: 4,
        pointHoverRadius: 6,
        pointBorderWidth: 2
      };
    }

    if (chartType === 'radar') {
      datasetConfig = {
        label: 'Counts',
        data: chartData,
        backgroundColor: isDarkMode
          ? 'rgba(96, 165, 250, 0.18)'
          : 'rgba(37, 99, 235, 0.14)',
        borderColor: isDarkMode ? '#60a5fa' : '#2563eb',
        pointBackgroundColor: isDarkMode ? '#60a5fa' : '#2563eb',
        pointBorderColor: isDarkMode ? '#0f172a' : '#ffffff',
        pointHoverBackgroundColor: isDarkMode ? '#ffffff' : '#1d4ed8',
        pointHoverBorderColor: isDarkMode ? '#60a5fa' : '#2563eb',
        borderWidth: 2
      };
    }

    if (chartType === 'bar') {
      datasetConfig = {
        label: 'Counts',
        data: chartData,
        backgroundColor: palette,
        borderRadius: 10,
        borderSkipped: false,
        maxBarThickness: 34
      };
    }

    const newChart = new Chart(ctx, {
      type: chartType as any,
      data: {
        labels,
        datasets: [datasetConfig]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        layout: {
          padding: {
            top: 8,
            right: 8,
            bottom: 8,
            left: 8
          }
        },
        plugins: {
          legend: {
            display: chartType !== 'bar',
            position: 'bottom',
            align: 'center',
            labels: {
              color: legendColor,
              usePointStyle: true,
              pointStyle: 'circle',
              padding: 18,
              boxWidth: 10,
              boxHeight: 10,
              font: {
                size: 12,
                weight: '600'
              }
            }
          },
          tooltip: {
            backgroundColor: isDarkMode ? '#111827' : '#ffffff',
            titleColor: isDarkMode ? '#f8fafc' : '#0f172a',
            bodyColor: isDarkMode ? '#e5e7eb' : '#334155',
            borderColor: isDarkMode ? 'rgba(255,255,255,0.08)' : 'rgba(15,23,42,0.08)',
            borderWidth: 1,
            padding: 12,
            displayColors: true
          }
        },
        scales: chartType === 'line' || chartType === 'bar' ? {
          x: {
            ticks: {
              color: textColor,
              font: {
                size: 11,
                weight: '500'
              }
            },
            grid: {
              display: false,
              drawBorder: false
            }
          },
          y: {
            beginAtZero: true,
            ticks: {
              color: textColor,
              font: {
                size: 11
              },
              precision: 0
            },
            grid: {
              color: gridColor,
              drawBorder: false
            }
          }
        } : chartType === 'radar' ? {
          r: {
            angleLines: {
              color: gridColor
            },
            grid: {
              color: gridColor
            },
            pointLabels: {
              color: textColor,
              font: {
                size: 11,
                weight: '500'
              }
            },
            ticks: {
              color: textColor,
              backdropColor: 'transparent',
              precision: 0
            }
          }
        } : {},
        elements: {
          arc: {
            borderWidth: 2
          }
        }
      }
    });

    if (chartId === 'chart1Canvas') {
      this.chart1 = newChart;
    }
    if (chartId === 'chart2Canvas') {
      this.chart2 = newChart;
    }
    if (chartId === 'chart3Canvas') {
      this.chart3 = newChart;
    }
  }


  /*changeChartType(type: string) {
      this.chartType = type;
      this.createChart();  // Recreate chart with new type
  }*/
    changeChartType(type: string, chart: string) {
    if (chart === 'chart1') {
      this.chart1Type = type;
      this.createChart('chart1Canvas', this.chart1Type);
    } else if (chart === 'chart2') {
      this.chart2Type = type;
      this.createChart('chart2Canvas', this.chart2Type);
    }
  }

    ngOnDestroy(): void {
      // this.pollSub?.unsubscribe();
      // this.busSub?.unsubscribe();
      this.busSub?.unsubscribe();
      this.stopPolling();
      if (this.providerPatientsSub) {
        this.providerPatientsSub?.unsubscribe();
      }
      try {
        this.chart1?.destroy?.();
      } catch {}
      this.chart1 = null;
      this.destroyProviderTrendChart();
    }

    trackByTableId(index: number, item: any): any {
    return item?.id ?? index;
    }

    /*private startPolling() {
      // cancel any previous polling (handles client switch too)
      this.pollSub?.unsubscribe();
      this.pollSub = timer(0, 300000) // immediately, then every 5m
        .subscribe(() => this.safeFetch());
    }*/
    startPolling(): void {
      if (this.isExternalUser) {
        return;
      }

      this.stopPolling();

      this._fetchHomePageData(); // initial immediate call
      this.fetchExtractionMetrics();

      this.pollingInterval = setInterval(() => {
        this._fetchHomePageData();
        this.fetchExtractionMetrics();
      }, 300000); // refresh both dashboard and extraction metrics
    }

    stopPolling(): void {
      if (this.pollingInterval) {
        clearInterval(this.pollingInterval);
        this.pollingInterval = null;
      }
    }

    private formatExtractionDate(date: Date | string | null): string | null {
  if (!date) {
    return null;
  }

  return this.datePipe.transform(new Date(date), 'MM/dd/yyyy');
}

    private buildExtractionMetricsRequest(
      countsOnly: boolean = true,
      statusOverride?: ExtractionStatus
    ): any {
  const request: any = {
    clientIds: this.getExtractionClientIds(),
    sources: [...this.selectedExtractionSources],
    fromDate: this.formatExtractionDate(this.startDate),
    toDate: this.formatExtractionDate(this.endDate),
    countsOnly: countsOnly ? 'true' : 'false'
  };

  const status = statusOverride ?? this.selectedExtractionStatus;

  // ALL means don't send status
  if (status !== 'ALL') {
    request.status = status;
  }

  // Never send officeIds

  return request;
}

  private getExtractionClientIds(): string[] {
    if (this.extractionClientScope === 'ALL') {
      return [...this.jwtClientIds];
    }

    const selectedClientId =
      this.authService.clientId ??
      this.readClientIdSafely();

    if (selectedClientId === null || selectedClientId === undefined || selectedClientId === '') {
      return [];
    }

    return [String(selectedClientId)];
  }

  private async initializeJwtClientIds(): Promise<void> {
    try {
      const token = await this.authService.getAccessToken();

      if (!token) {
        this.jwtClientIds = [];
        return;
      }

      const decodedToken: any = jwtDecode(token);
      this.jwtClientIds = this.parseClientIdsClaim(decodedToken?.client_id);
    } catch (error) {
      console.error('Unable to read client_id from JWT:', error);
      this.jwtClientIds = [];
    }
  }

  private parseClientIdsClaim(clientIdClaim: unknown): string[] {
    if (clientIdClaim === null || clientIdClaim === undefined) {
      return [];
    }

    let values: unknown[] = [];

    if (Array.isArray(clientIdClaim)) {
      values = clientIdClaim;
    } else if (typeof clientIdClaim === 'number') {
      values = [clientIdClaim];
    } else if (typeof clientIdClaim === 'string') {
      const trimmed = clientIdClaim.trim();

      if (!trimmed) {
        return [];
      }

      try {
        const parsed = JSON.parse(trimmed);
        values = Array.isArray(parsed) ? parsed : [parsed];
      } catch {
        values = trimmed
          .replace(/^\[/, '')
          .replace(/\]$/, '')
          .split(',')
          .map(value => value.trim());
      }
    }

    return Array.from(
      new Set(
        values
          .map(value => String(value).trim())
          .filter(value => value.length > 0)
      )
    );
  }

  async setExtractionClientScope(scope: ExtractionClientScope): Promise<void> {
    if (this.extractionClientScope === scope) {
      return;
    }

    this.extractionClientScope = scope;

    if (scope === 'ALL' && this.jwtClientIds.length === 0) {
      await this.initializeJwtClientIds();
    }

    this.resetExtractionDrilldown();
    this.fetchExtractionMetrics();
  }

  private fetchExtractionMetrics(): void {

  const requestId = ++this.extractionMetricsRequestId;
  const body = this.buildExtractionMetricsRequest(true);

  if (!body.clientIds?.length || !body.sources?.length) {
    this.extractionTotalCount = 0;
    this.extractionSuccessCount = 0;
    this.extractionFailedCount = 0;
    this.isExtractionMetricsLoading = false;
    this.resetExtractionDrilldown();
    this.cdr.detectChanges();
    return;
  }

  this.ngZone.run(() => {
    this.isExtractionMetricsLoading = true;
    this.cdr.detectChanges();
  });

  this.reportsService
    .getExtractionMetrics(body)
    .pipe(first())
    .subscribe({

      next: (response: any) => {
        if (requestId !== this.extractionMetricsRequestId) {
          return;
        }

        this.ngZone.run(() => {

          this.extractionTotalCount =
            Number(response?.totalCount ?? 0);

          this.extractionSuccessCount =
            Number(response?.successCount ?? 0);

          this.extractionFailedCount =
            Number(response?.failedCount ?? 0);

          this.isExtractionMetricsLoading = false;
          this.cdr.detectChanges();
        });
      },

      error: () => {
        if (requestId !== this.extractionMetricsRequestId) {
          return;
        }

        this.ngZone.run(() => {

          this.extractionTotalCount = 0;
          this.extractionSuccessCount = 0;
          this.extractionFailedCount = 0;
          this.isExtractionMetricsLoading = false;
          this.cdr.detectChanges();
        });
      }
    });
  }

  get hasExtractionData(): boolean {
  return (
    this.extractionTotalCount > 0 ||
    this.extractionSuccessCount > 0 ||
    this.extractionFailedCount > 0
  );
  }

  get extractionSuccessRate(): number {
    return this.extractionTotalCount > 0
      ? (this.extractionSuccessCount / this.extractionTotalCount) * 100
      : 0;
  }

  get extractionFailedRate(): number {
    return this.extractionTotalCount > 0
      ? (this.extractionFailedCount / this.extractionTotalCount) * 100
      : 0;
  }

  get extractionDoughnutBackground(): string {
    if (this.extractionTotalCount <= 0) {
      return 'conic-gradient(#e2e8f0 0 100%)';
    }

    const successRate =
      Math.max(
        0,
        Math.min(
          100,
          this.extractionSuccessRate
        )
      );

    return (
      'conic-gradient(' +
      '#4ade80 0 ' +
      successRate +
      '%, ' +
      '#f87171 ' +
      successRate +
      '% 100%)'
    );
  }

  get extractionSuccessDoughnutBackground(): string {
    const rate =
      Math.max(
        0,
        Math.min(
          100,
          this.extractionSuccessRate
        )
      );

    return (
      'conic-gradient(' +
      '#22c55e 0 ' +
      rate +
      '%, ' +
      '#bbf7d0 ' +
      rate +
      '% 100%)'
    );
  }

  get extractionFailedDoughnutBackground(): string {
    const rate =
      Math.max(
        0,
        Math.min(
          100,
          this.extractionFailedRate
        )
      );

    return (
      'conic-gradient(' +
      '#ef4444 0 ' +
      rate +
      '%, ' +
      '#fecaca ' +
      rate +
      '% 100%)'
    );
  }

  get extractionDrilldownTotal(): number {
    if (this.extractionDrilldownStatus === 'SUCCESS') {
      return this.extractionSuccessCount;
    }

    if (this.extractionDrilldownStatus === 'FAILED') {
      return this.extractionFailedCount;
    }

    return 0;
  }

  getExtractionPatientName(patient: ExtractionPatientRow): string {
    return [
      patient?.firstName,
      patient?.lastName
    ]
      .filter(Boolean)
      .join(' ')
      .trim() || '-';
  }

  getExtractionSourceLabel(source: string): string {
    if (!source) {
      return '-';
    }

    return source
      .replace(/_/g, ' ')
      .replace(/\b\w/g, character => character.toUpperCase());
  }

  showExtractionPatientPreview(
    status: 'SUCCESS' | 'FAILED'
  ): void {

    this.extractionDrilldownStatus = status;
    this.extractionDrilldownError = false;

    const availableCount =
      status === 'SUCCESS'
        ? this.extractionSuccessCount
        : this.extractionFailedCount;

    if (availableCount <= 0) {
      this.extractionPatients = [];
      this.extractionDrilldownLoading = false;
      return;
    }

    const body =
      this.buildExtractionMetricsRequest(
        false,
        status
      );

    if (!body.clientIds?.length || !body.sources?.length) {
      this.extractionPatients = [];
      this.extractionDrilldownLoading = false;
      return;
    }

    const cacheKey = JSON.stringify({
      clientIds: body.clientIds,
      sources: body.sources,
      fromDate: body.fromDate,
      toDate: body.toDate,
      status
    });

    const cached =
      this.extractionDrilldownCache[cacheKey];

    if (cached) {
      this.extractionPatients = cached;
      this.extractionDrilldownLoading = false;
      this.cdr.detectChanges();
      return;
    }

    this.extractionPatients = [];
    this.extractionDrilldownLoading = true;
    this.cdr.detectChanges();

    this.reportsService
      .getExtractionMetrics(body)
      .pipe(first())
      .subscribe({
        next: (response: any) => {
          this.ngZone.run(() => {
            const patients =
              Array.isArray(response?.responses)
                ? response.responses
                : [];

            this.extractionDrilldownCache[cacheKey] =
              patients;

            if (
              this.extractionDrilldownStatus === status
            ) {
              this.extractionPatients = patients;
              this.extractionDrilldownLoading = false;
              this.extractionDrilldownError = false;
              this.cdr.detectChanges();
            }
          });
        },

        error: () => {
          this.ngZone.run(() => {
            if (
              this.extractionDrilldownStatus === status
            ) {
              this.extractionPatients = [];
              this.extractionDrilldownLoading = false;
              this.extractionDrilldownError = true;
              this.cdr.detectChanges();
            }
          });
        }
      });
  }

  closeExtractionPatientPreview(): void {
    this.extractionDrilldownStatus = null;
    this.extractionPatients = [];
    this.extractionDrilldownLoading = false;
    this.extractionDrilldownError = false;
  }

  private resetExtractionDrilldown(): void {
    this.closeExtractionPatientPreview();
    this.extractionDrilldownCache = {};
  }

  get hasActiveExtractionFilters(): boolean {
    return (
      this.selectedExtractionStatus !== 'ALL' ||
      this.selectedExtractionSources.length !== this.extractionSources.length
    );
  }

  onExtractionStatusChange(): void {
    this.resetExtractionDrilldown();
    this.fetchExtractionMetrics();
  }

  selectAllExtractionSources(): void {
    this.selectedExtractionSources = [...this.extractionSources];
  }

  clearAllExtractionSources(): void {
    this.selectedExtractionSources = [];
  }

  onExtractionSourcesChange(): void {
    this.resetExtractionDrilldown();
    this.fetchExtractionMetrics();
  }

  toggleExtractionFilters(event: MouseEvent): void {
    event.stopPropagation();
    this.showExtractionFilters = !this.showExtractionFilters;
  }

  applyExtractionFilters(): void {
    this.showExtractionFilters = false;
    this.resetExtractionDrilldown();
    this.fetchExtractionMetrics();
  }

  resetExtractionFilters(): void {
    this.selectedExtractionStatus = 'ALL';
    this.selectedExtractionSources = [...this.extractionSources];
    this.resetExtractionDrilldown();
    this.fetchExtractionMetrics();
    this.showExtractionFilters = false;
  }


    trackByAgentUserId(
      index: number,
      agent: any
    ): string | number {
      return agent?.userId ||
        agent?.userName ||
        index;
    }

    private safeFetch() {
      const cid = this.readClientIdSafely();
      if (!cid) return; // guard: still no client, skip
      this._fetchHomePageData();
    }

    private readClientIdSafely(): string | null {
      // Your auth.getClientId() returns string[] in the signature, but seems to hold a string.
      // We'll normalize whatever comes back into a string or null.
      const fromAuth = (this.authService as any).getClientId?.();
      const fromSession = sessionStorage.getItem('clientId');

      const raw = fromAuth ?? (fromSession ? JSON.parse(fromSession) : null);
      if (Array.isArray(raw)) return raw[0] ?? null;
      return raw ? String(raw) : null;
    }

    onInsuranceDropdownChange(opened: boolean): void {

      if (opened) {
        this.insuranceDropdownActive = true;
        return;
      }

      // Wait until the click that closed mat-select finishes.
      // Otherwise document:click will also close the filter popup.
      setTimeout(() => {
        this.insuranceDropdownActive = false;
      }, 0);
    }

    private async initializeExternalGroupAccess(): Promise<void> {
    this.isExternalAdminOrSupervisor = false;

    if (!this.isExternalUser) {
      return;
    }

    try {
      const token =
        await this.authService.getAccessToken();

      if (!token) {
        return;
      }

      const decodedToken: any =
        jwtDecode(token);

      const groupClaim =
        decodedToken?.group ??
        decodedToken?.groups ??
        [];

      const groups: string[] =
        (Array.isArray(groupClaim)
          ? groupClaim
          : [groupClaim]
        )
          .filter(Boolean)
          .map((group: any) =>
            String(group)
              .replace(/^\/+/, '')
              .trim()
              .toLowerCase()
          );

      this.isExternalAdminOrSupervisor =
        groups.includes('admin') ||
        groups.includes('supervisor');

    } catch (error) {
      console.error(
        'Unable to read external user groups:',
        error
      );

      this.isExternalAdminOrSupervisor = false;
    }
    }

    // Toggle handler PPO/ HMO
    setPlan(plan: 'PPO' | 'HMO') {
      if (this.selectedPlanType !== plan) {
        this.selectedPlanType = plan;
        localStorage.setItem('dashboardPlanType', plan);
        this.onPlanTypeChange(); // already calls _fetchHomePageData()
      }
    }

    // Toggle handler
    onPlanTypeChange(): void {
      localStorage.setItem('dashboardPlanType', this.selectedPlanType);
      if (this.isExternalUser) {
        this.loadProviderDashboard();
        return;
      }
      this._fetchHomePageData();
    }

    private loadProviderDashboard(): void {

      this.fetchAdminPresence();

      if (!this.isExternalAdminOrSupervisor) {

        this.fetchProviderPatients();

      } else {

        this.providerPatients = [];
        this.providerTotalRecords = 0;
      }
    }
    private normalizeVolumeTrend(
      trend: any
    ): VolumeTrendPoint[] {

      if (!Array.isArray(trend)) {
        return [];
      }

      return trend
        .filter((item: any) => !!item?.date)
        .map((item: any) => ({
          date: String(item.date),

          totalCount:
            Number(item.totalCount ?? 0),

          pending:
            Number(item.pending ?? 0),

          verified:
            Number(item.verified ?? 0),

          backlog:
            Number(item.backlog ?? 0),

          notVerified:
            Number(item.notVerified ?? 0),

          assigned:
            Number(item.assigned ?? 0),

          unassigned:
            Number(item.unassigned ?? 0)
        }))
        .sort(
          (
            first: VolumeTrendPoint,
            second: VolumeTrendPoint
          ) =>
            first.date.localeCompare(second.date)
        );
    }
    private getVolumeTrendFromResponse(
      response: any
    ): VolumeTrendPoint[] {

      /*
      * Preferred:
      *
      * {
      *   volumeTrend: [...]
      * }
      */
      if (Array.isArray(response?.volumeTrend)) {
        return this.normalizeVolumeTrend(
          response.volumeTrend
        );
      }

      /*
      * Also support:
      *
      * {
      *   overallData: {
      *     volumeTrend: [...]
      *   }
      * }
      */
      if (
        Array.isArray(
          response?.overallData?.volumeTrend
        )
      ) {
        return this.normalizeVolumeTrend(
          response.overallData.volumeTrend
        );
      }

      /*
      * Admin response may have multiple clients.
      * If volumeTrend is returned inside each client,
      * aggregate all clients by date.
      */
      const clients =
        Array.isArray(response?.clients)
          ? response.clients
          : [];

      const hasClientTrend =
        clients.some(
          (client: any) =>
            Array.isArray(
              client?.overallData?.volumeTrend
            )
        );

      if (!hasClientTrend) {
        return [];
      }

      const byDate =
        new Map<string, VolumeTrendPoint>();

      clients.forEach((client: any) => {

        const trend =
          client?.overallData?.volumeTrend;

        if (!Array.isArray(trend)) {
          return;
        }

        trend.forEach((item: any) => {

          if (!item?.date) {
            return;
          }

          const date =
            String(item.date);

          const current =
            byDate.get(date) || {
              date,
              totalCount: 0,
              pending: 0,
              verified: 0,
              backlog: 0,
              notVerified: 0,
              assigned: 0,
              unassigned: 0
            };

          current.totalCount +=
            Number(item.totalCount ?? 0);

          current.pending +=
            Number(item.pending ?? 0);

          current.verified +=
            Number(item.verified ?? 0);

          current.backlog +=
            Number(item.backlog ?? 0);

          current.notVerified +=
            Number(item.notVerified ?? 0);

          current.assigned +=
            Number(item.assigned ?? 0);

          current.unassigned +=
            Number(item.unassigned ?? 0);

          byDate.set(date, current);
        });
      });

      return Array
        .from(byDate.values())
        .sort(
          (
            first: VolumeTrendPoint,
            second: VolumeTrendPoint
          ) =>
            first.date.localeCompare(second.date)
        );
    }
    private formatTrendDate(
      value: string
    ): string {

      if (!value) {
        return '';
      }

      /*
      * Append local midnight so "2026-08-01"
      * doesn't shift dates because of UTC parsing.
      */
      const date =
        new Date(
          `${value}T00:00:00`
        );

      return (
        this.datePipe.transform(
          date,
          'MMM d'
        ) || value
      );
    }
    private buildVolumeTrendChart(
      canvasId: string,
      trend: VolumeTrendPoint[],
      series: TrendSeries[]
    ): any {

      const canvas =
        document.getElementById(
          canvasId
        ) as HTMLCanvasElement | null;

      if (
        !canvas ||
        !trend ||
        trend.length === 0
      ) {
        return null;
      }

      const isDark =
        this.isDarkMode;

      const textColor =
        isDark
          ? '#e5e7eb'
          : '#64748b';

      const gridColor =
        isDark
          ? 'rgba(255,255,255,0.08)'
          : 'rgba(148,163,184,0.15)';

      const labels =
        trend.map(
          point =>
            this.formatTrendDate(
              point.date
            )
        );

      const hidePoints =
        trend.length > 31;

      const datasets =
        series.map(item => ({
          label: item.label,

          data:
            trend.map(
              point =>
                Number(
                  point[item.key] ?? 0
                )
            ),

          borderColor:
            item.color,

          backgroundColor:
            item.color,

          borderWidth: 2,

          fill: false,

          lineTension: 0.3,

          pointRadius:
            hidePoints
              ? 0
              : 2.5,

          pointHoverRadius: 5,

          pointBorderWidth: 1
        }));

      return new Chart(
        canvas,
        {
          type: 'line',

          data: {
            labels,
            datasets
          },

          options: {
            responsive: true,
            maintainAspectRatio: false,

            legend: {
              display: true,
              position: 'bottom',

              labels: {
                fontColor: textColor,
                usePointStyle: true,
                boxWidth: 8,
                padding: 14,
                fontSize: 11
              }
            },

            tooltips: {
              mode: 'index',
              intersect: false,
              displayColors: true,

              callbacks: {
                title: (
                  tooltipItems: any[]
                ) => {

                  if (
                    !tooltipItems ||
                    !tooltipItems.length
                  ) {
                    return '';
                  }

                  const index =
                    tooltipItems[0].index;

                  return (
                    trend[index]?.date || ''
                  );
                },

                label: (
                  tooltipItem: any,
                  data: any
                ) => {

                  const dataset =
                    data.datasets[
                      tooltipItem.datasetIndex
                    ];

                  return (
                    dataset.label +
                    ': ' +
                    tooltipItem.yLabel
                  );
                }
              }
            },

            hover: {
              mode: 'nearest',
              intersect: false
            },

            scales: {
              xAxes: [
                {
                  gridLines: {
                    display: false
                  },

                  ticks: {
                    fontColor: textColor,
                    autoSkip: true,
                    maxTicksLimit: 12,
                    maxRotation: 0,
                    minRotation: 0
                  },

                  scaleLabel: {
                    display: true,
                    labelString: 'Date',
                    fontColor: textColor
                  }
                }
              ],

              yAxes: [
                {
                  ticks: {
                    beginAtZero: true,
                    precision: 0,
                    fontColor: textColor
                  },

                  gridLines: {
                    color: gridColor
                  },

                  scaleLabel: {
                    display: true,
                    labelString: 'Volume',
                    fontColor: textColor
                  }
                }
              ]
            }
          } as any
        }
      );
    }
    private buildParams(planType: 'PPO' | 'HMO', timeZoneOverride?: string) {
      return {
        clientId: this.authService.clientId ?? null,
        fromDate: this.startDate ? this.formatStartOfDay(this.startDate) : null,
        toDate: this.endDate ? this.formatEndOfDay(this.endDate) : null,
        userTimeZone: timeZoneOverride ?? this.authService.getTimeZone(),
        planType // <— new
      };
    }

    private buildManagerParams(planType: 'PPO' | 'HMO', timeZoneOverride?: string) {
      return {
        fromDate: this.startDate ? this.formatStartOfDay(this.startDate) : null,
        toDate: this.endDate ? this.formatEndOfDay(this.endDate) : null,
        userTimeZone: timeZoneOverride ?? this.authService.getTimeZone(),
        planType // <— new
      };
    }

    private buildAdminParams(
      planType: 'PPO' | 'HMO',
      timeZoneOverride?: string
    ): any {
      const params: any = {
        clientId: this.authService.clientId || null,

        fromDate: this.startDate
          ? this.formatStartOfDay(this.startDate)
          : null,

        toDate: this.endDate
          ? this.formatEndOfDay(this.endDate)
          : null,

        userTimeZone:
          timeZoneOverride ||
          this.selectedTimezone ||
          this.authService.getTimeZone(),

        planType: planType
      };

      if (!this.authService.isExternalUser()) {
        params.isAdmin = true;
      }

      return params;
    }

    private destroyChartsSafely(includeChart1: boolean = true): void {

  if (includeChart1) {
    try {
      this.chart1?.destroy?.();
    } catch {}

    this.chart1 = null;
  }

  try {
    this.chart2?.destroy?.();
  } catch {}
  this.chart2 = null;

  try {
    this.chart3?.destroy?.();
  } catch {}
  this.chart3 = null;

  try {
    this.verificationTimeChart?.destroy?.();
  } catch {}
  this.verificationTimeChart = null;
    }

    // Function to calculate the verified percentage dynamically
    /*get verifiedPercentage(): number {
        return this.totalCount > 0 ? (this.totalVerified / this.totalCount) * 100 : 0;
    }*/
    get verifiedPercentage(): number {
      const total = (this.totalAssigned ?? 0) + (this.totalUnAssigned ?? 0);
      const denom = (this.totalCount ?? 0) || total || 1;
      const pct = ((this.totalVerified ?? 0) / denom) * 100;
      return Math.max(0, Math.min(100, pct)); // clamp 0..100 like your function did
    }

    toggleTheme(): void {
        this.isDarkMode = !this.isDarkMode;
        localStorage.setItem('theme', this.isDarkMode ? 'dark' : 'light');
        this.applyTheme();
    }
    private applyTheme(): void {
        if (this.isDarkMode) {
            document.body.classList.add('bg-dark', 'text-light');
            document.body.classList.remove('bg-light', 'text-dark');
        } else {
            document.body.classList.add('bg-light', 'text-dark');
            document.body.classList.remove('bg-dark', 'text-light');
        }
    }

    formatStartOfDay(date: Date | string | null): string | null {
        if (!date) {
            return null;
        }

        const dateObj = new Date(date);
        dateObj.setHours(0, 0, 0, 0);
        return this.datePipe.transform(dateObj, 'yyyy-MM-ddTHH:mm:ss');
    }

    formatEndOfDay(date: Date | string | null): string | null {
        if (!date) {
            return null;
        }

        const dateObj = new Date(date);
        dateObj.setHours(23, 59, 59, 999);
        return this.datePipe.transform(dateObj, 'yyyy-MM-ddTHH:mm:ss');
    }

   getAgentName(user: AdminAgentPresence): string {
      const fullName = `${user?.firstName ?? ''} ${user?.lastName ?? ''}`.trim();

      return fullName || user?.userName || 'Unknown Agent';
    }

    getVerificationCount(
      user: AdminAgentPresence,
      status: 'VERIFIED' | 'NOT_VERIFIED' | 'PENDING' | 'BACKLOG'
    ): number {
      return user?.verificationStatus?.[status]?.count ?? 0;
    }

    getAverageTime(
      user: AdminAgentPresence,
      formType: 'SHORT FORM' | 'FULL FORM'
    ): string {
      return user?.averageCompletionTime?.[formType]?.averageFormatted ?? '0 sec';
    }

    getProviderName(
      provider: ProviderStatus
    ): string {

      const fullName = [
        provider?.firstName,
        provider?.lastName
      ]
        .filter(Boolean)
        .join(' ')
        .trim();

      return fullName || provider?.userName || '-';
    }


    getProviderVerificationCount(
      provider: ProviderStatus,
      status:
        | 'VERIFIED'
        | 'PENDING'
        | 'NOT_VERIFIED'
        | 'BACKLOG'
    ): number {

      return (
        provider?.verificationStatus?.[status]?.count ??
        0
      );
    }


    getProviderPresenceLabel(
      provider: ProviderStatus
    ): string {

      if (provider?.online === true) {
        return 'Online';
      }

      if (provider?.online === false) {
        return 'Offline';
      }

      return 'Unavailable';
    }


    getProviderPresenceBadgeClass(
      provider: ProviderStatus
    ): string {

      if (provider?.online === true) {
        return 'badge-online';
      }

      if (provider?.online === false) {
        return 'badge-offline';
      }

      return 'badge-unavailable';
    }


    getProviderPresenceDotClass(
      provider: ProviderStatus
    ): string {

      if (provider?.online === true) {
        return 'dot-online';
      }

      if (provider?.online === false) {
        return 'dot-offline';
      }

      return 'dot-unavailable';
    }


    trackByProviderOfficeGroup(
      index: number,
      office: ProviderOfficeGroup
    ): string | number {

      return office?.officeId ?? index;
    }


    trackByProvider(
      index: number,
      provider: ProviderStatus
    ): string | number {

      return (
        provider?.userId ||
        provider?.keycloakUserId ||
        provider?.userName ||
        index
      );
    }


    private normalizeProviderOfficeGroups(
      providerStatus: ProviderOfficeGroup[] | null | undefined
    ): ProviderOfficeGroup[] {

      if (!Array.isArray(providerStatus)) {
        return [];
      }

      return providerStatus.map(
        (office: ProviderOfficeGroup) => ({

          officeId:
            Number(office?.officeId ?? 0),

          officeName:
            office?.officeName || '-',

          totalCount:
            Number(office?.totalCount ?? 0),

          providers:
            Array.isArray(office?.providers)
              ? office.providers.map(
                  (provider: ProviderStatus) => ({
                    ...provider,

                    totalCount:
                      Number(
                        provider?.totalCount ?? 0
                      ),

                    activeSessionCount:
                      Number(
                        provider?.activeSessionCount ?? 0
                      ),

                    online:
                      provider?.online ?? null,

                    verificationStatus:
                      provider?.verificationStatus ?? {}
                  })
                )
              : []
        })
      );
    }

    private patchExternalDashboardSummary(response: any): void {

      const overallStatus =
        this.getOverallStatusFromResponse(response);

      const assigned =
        overallStatus?.ASSIGNED?.count || 0;

      const unassigned =
        overallStatus?.UNASSIGNED?.count || 0;

      const verified =
        overallStatus?.VERIFIED?.count || 0;

      const notVerified =
        overallStatus?.NOT_VERIFIED?.count || 0;

      const pending =
        overallStatus?.PENDING?.count || 0;

      this.providerSummary = {
        totalRequests: assigned + unassigned,
        assigned,
        verified,
        notVerified,
        inProgress: pending
      };
    }

    private createProviderTrendChart(): void {

      this.destroyProviderTrendChart();

      if (
        !this.providerTrendData ||
        this.providerTrendData.length === 0
      ) {
        return;
      }

      const series: TrendSeries[] = [
        {
          label: 'Total Requests',
          key: 'totalCount',
          color: '#d6b33a'
        },
        {
          label: 'Assigned',
          key: 'assigned',
          color: '#5d97d0'
        },
        {
          label: 'Verified',
          key: 'verified',
          color: '#68a67e'
        },
        {
          label: 'Not Verified',
          key: 'notVerified',
          color: '#8d68c7'
        },
        {
          label: 'In Progress',
          key: 'pending',
          color: '#db964d'
        }
      ];

      this.providerTrendChart =
        this.buildVolumeTrendChart(
          'providerTrendChart',
          this.providerTrendData,
          series
        );
    }
    private destroyProviderTrendChart(): void {

    if (this.providerTrendChart) {

      try {
        this.providerTrendChart.destroy();
      } catch (error) {
        console.warn(
          'Unable to destroy provider trend chart',
          error
        );
      }

      this.providerTrendChart = null;
    }
    }
    private getOverallStatusFromResponse(response: any): any {
      return (
        response?.overallStatus ||
        response?.overallData?.overallStatus ||
        response?.clients?.[0]?.overallData?.overallStatus ||
        {}
      );
    }

    private fetchAdminPresence(timeZoneOverride?: string): void {

    if (this.isExternalUser) {
      this.providerTrendLoading = true;
      this.providerTrendError = false;
    }
    const params = this.buildAdminParams(
      this.selectedPlanType,
      timeZoneOverride
    );

    this.isAdminPresenceLoading = true;
    this.adminPresenceError = false;

    this.reportsService
      .getAdminHomeReports(params)
      .pipe(first())
      .subscribe({
        next: (response: AdminPresenceResponse) => {
          this.ngZone.run(() => {
          if (this.isExternalUser) {
                  this.patchExternalDashboardSummary(response);
                }
          if (this.isExternalUser) {

            this.providerTrendData =
              this.getVolumeTrendFromResponse(
                response
              );

            this.providerTrendLoading = false;
            this.providerTrendError = false;
          }
                if (
            this.isExternalUser &&
            this.isExternalAdminOrSupervisor
          ) {
              this.providerOfficeGroups =
                this.normalizeProviderOfficeGroups(
                  response?.providerStatus
                );
          }
          // this.ngZone.run(() => {
            this.adminClients = (response?.clients ?? []).map(client => ({
            ...client,

    users: [...(client.users ?? [])],

    overallData: {
      ...(client.overallData ?? {}),

      totalUsers:
        client?.overallData?.totalUsers ??
        client?.users?.length ??
        0,

      onlineUsers:
        client?.overallData?.onlineUsers ??
        (client?.users ?? []).filter(user => user.online).length,

      offlineUsers:
        client?.overallData?.offlineUsers ??
        (client?.users ?? []).filter(user => !user.online).length,

      overallStatus: {
        PENDING:
          client?.overallData?.overallStatus?.PENDING ??
          { count: 0, formTypes: {} },

        VERIFIED:
          client?.overallData?.overallStatus?.VERIFIED ??
          { count: 0, formTypes: {} },

        BACKLOG:
          client?.overallData?.overallStatus?.BACKLOG ??
          { count: 0, formTypes: {} },

        NOT_VERIFIED:
          client?.overallData?.overallStatus?.NOT_VERIFIED ??
          { count: 0, formTypes: {} },

        ASSIGNED:
          client?.overallData?.overallStatus?.ASSIGNED ??
          { count: 0, formTypes: {} },

        UNASSIGNED:
          client?.overallData?.overallStatus?.UNASSIGNED ??
          { count: 0, formTypes: {} }
      },

      overallAverageCompletionTime: {
        'ELIG CHECK':
          client?.overallData?.overallAverageCompletionTime?.['ELIG CHECK'] ??
          { averageSeconds: 0, averageFormatted: '0 sec' },

        'SHORT FORM':
          client?.overallData?.overallAverageCompletionTime?.['SHORT FORM'] ??
          { averageSeconds: 0, averageFormatted: '0 sec' },

        'FULL FORM':
          client?.overallData?.overallAverageCompletionTime?.['FULL FORM'] ??
          { averageSeconds: 0, averageFormatted: '0 sec' }
      },

      totalOverallCount:
        client?.overallData?.totalOverallCount ?? 0
    }
  }));

            this.calculateUniquePresenceTotals();

            this.cdr.detectChanges();
            if (this.isExternalUser) {

              setTimeout(() => {

                this.createProviderTrendChart();

              }, 0);
            }
          });
        },

        error: error => {
          console.error('Error fetching admin presence:', error);

          this.ngZone.run(() => {
            this.adminClients = [];
            this.onlineUsersCount = 0;
            this.offlineUsersCount = 0;
            this.totalUniqueUsersCount = 0;
            this.adminPresenceError = true;
            this.isAdminPresenceLoading = false;

            this.cdr.detectChanges();
          });

          if (this.isExternalUser) {
            this.providerSummary = {
              totalRequests: 0,
              assigned: 0,
              verified: 0,
              notVerified: 0,
              inProgress: 0
            };
          }

          if (this.isExternalUser) {

            this.providerTrendData = [];

            this.providerTrendLoading = false;
            this.providerTrendError = true;

            this.destroyProviderTrendChart();
          }          
          if (this.isExternalAdminOrSupervisor) {
             this.providerOfficeGroups = [];
          }
          
        },

        complete: () => {
          this.ngZone.run(() => {
            this.isAdminPresenceLoading = false;

            this.cdr.detectChanges();
          });
        }
      });
    }
    private calculateUniquePresenceTotals(): void {
  const uniqueUsers = new Map<string, AdminAgentPresence>();

  this.adminClients.forEach(client => {
    client.users.forEach(user => {
      const uniqueKey =
        user.userId ||
        user.keycloakUserId ||
        user.userName;

      const existingUser = uniqueUsers.get(uniqueKey);

      if (!existingUser) {
        uniqueUsers.set(uniqueKey, { ...user });
        return;
      }

      /*
       * If the same user is online under any client,
       * treat that user as online overall.
       */
      uniqueUsers.set(uniqueKey, {
        ...existingUser,
        online: existingUser.online || user.online,
        activeSessionCount: Math.max(
          existingUser.activeSessionCount ?? 0,
          user.activeSessionCount ?? 0
        ),
        lastSeenAt:
          existingUser.lastSeenAt ??
          user.lastSeenAt
      });
    });
  });

  const users = Array.from(uniqueUsers.values());

  this.totalUniqueUsersCount = users.length;
  this.onlineUsersCount =
    users.filter(user => user.online === true).length;

  this.offlineUsersCount =
    users.filter(user => user.online !== true).length;
    }
    _fetchHomePageData(timeZoneOverride?: string) {
        const plan = this.selectedPlanType;
        const params = this.buildParams(plan, timeZoneOverride);
        const mparams = this.buildManagerParams(plan, timeZoneOverride);

        this.isLoading = true;

         // Separate admin API
        this.fetchAdminPresence(timeZoneOverride);

        // 🧩 1️⃣ Fetch Agent’s Table Data (individual agent stats)
        this.reportsService.getHomeReports(params).pipe(first()).subscribe(
            (response: any) => {
                if (response) {
                    // Agents Table Data
                    this.agentsTableData = response?.agentsStatus ?? [];

                    // Dashboard Summary Cards
                    this.overallStatus     = response?.overallStatus ?? {};
                    this.totalCount        = response?.totalOverallCount ?? 0;
                    this.totalAssigned     = response?.overallStatus?.ASSIGNED?.count ?? 0;
                    this.totalUnAssigned   = response?.overallStatus?.UNASSIGNED?.count ?? 0;
                    this.totalVerified     = response?.overallStatus?.VERIFIED?.count ?? 0;
                    this.totalPending      = response?.overallStatus?.PENDING?.count ?? 0;
                    this.totalBacklog      = response?.overallStatus?.BACKLOG?.count ?? 0;
                    this.totalNotVerified  = response?.overallStatus?.NOT_VERIFIED?.count ?? 0;

                   /* // Optional: compute percentages for charts
                    this.verifiedPercentage = this.totalCount
                        ? (this.totalVerified / this.totalCount) * 100
                        : 0;*/
                    this.buildVerificationTimeAnalytics(response);

                    // Update dashboard statistics across app
                    this.statsService.updateStats({
                        totalCount: this.totalCount,
                        totalUnAssigned: this.totalUnAssigned,
                        totalAssigned: this.totalAssigned,
                        totalVerified: this.totalVerified,
                        totalPending: this.totalPending,
                        totalBacklog: this.totalBacklog,
                        totalNotVerified: this.totalNotVerified
                    });
                }

                // Refresh home-report charts without touching the separate Extraction Metrics chart.
                this.destroyChartsSafely(false);

                this.ngZone.run(() => {
                  this.cdr.detectChanges();

                  setTimeout(() => {

                    this.createChart(
                      'chart2Canvas',
                      this.chart2Type
                    );

                    this.createChart(
                      'chart3Canvas',
                      this.chart3Type
                    );

                  }, 0);
                });
            },
            (error) => {
                // console.error('Error fetching home reports:', error);
                this.isLoading = false;
            }
        ).add(() => {

            // 🧩 2️⃣ Fetch Project-wise Data (Manager View)
            this.reportsService.getMangerHomeReports(mparams).pipe(first()).subscribe(
                (mgr: any) => {
                    const clients = mgr?.clientStats ?? [];

                    this.projectsTableData = clients.map((c: any) => ({
                        projectName: c.clientName,
                        agents: [{
                            firstName: c.clientName,
                            lastName: '',
                            userName: '-',
                            totalCount: c?.totalOverallCount ?? 0,

                            // for badges
                            verificationStatusCount: {
                                NOT_VERIFIED: c?.overallStatusCount?.NOT_VERIFIED ?? 0,
                                VERIFIED:     c?.overallStatusCount?.VERIFIED     ?? 0,
                                PENDING:      c?.overallStatusCount?.PENDING      ?? 0,
                                BACKLOG:      c?.overallStatusCount?.BACKLOG     ?? 0,
                                ASSIGNED:     c?.overallStatusCount?.ASSIGNED    ?? 0,
                                UNASSIGNED:   c?.overallStatusCount?.UNASSIGNED   ?? 0,
                            },

                            // for tooltips
                            verificationStatus: {
                                NOT_VERIFIED: c?.overallStatus?.NOT_VERIFIED ?? { count: 0, formTypes: {} },
                                VERIFIED:     c?.overallStatus?.VERIFIED     ?? { count: 0, formTypes: {} },
                                PENDING:      c?.overallStatus?.PENDING      ?? { count: 0, formTypes: {} },
                                BACKLOG:      c?.overallStatus?.BACKLOG      ?? { count: 0, formTypes: {} },
                                ASSIGNED:     c?.overallStatus?.ASSIGNED     ?? { count: 0, formTypes: {} },
                                UNASSIGNED:   c?.overallStatus?.UNASSIGNED   ?? { count: 0, formTypes: {} },
                            }
                        }]
                    }));
                },
                (error) => {
                    // console.error('Error fetching manager home reports:', error);
                }
            ).add(() => {
                this.isLoading = false;
            });
        });
    }

    private createVerificationTimeChart(shortSeconds: number, fullSeconds: number, overallSeconds: number): void {
  const ctx = document.getElementById('verificationTimeChart') as HTMLCanvasElement | null;
  if (!ctx) {
    return;
  }

  if (this.verificationTimeChart) {
    this.verificationTimeChart.destroy();
  }

  this.verificationTimeChart = new Chart(ctx, {
    type: 'bar',
    data: {
      labels: ['Short Form', 'Full Form', 'Overall'],
      datasets: [{
        label: 'Average Verification Time',
        data: [
          Math.round(shortSeconds / 60 * 100) / 100,
          Math.round(fullSeconds / 60 * 100) / 100,
          Math.round(overallSeconds / 60 * 100) / 100
        ],
        backgroundColor: ['#22c55e', '#2563eb', '#a855f7'],
        borderRadius: 10,
        maxBarThickness: 60
      }]
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        display: false
      },
      tooltips: {
        callbacks: {
          label: (tooltipItem: any) => {
            const seconds = [shortSeconds, fullSeconds, overallSeconds][tooltipItem.index];
            return this.formatSeconds(seconds);
          }
        }
      },
      scales: {
        yAxes: [{
          ticks: {
            beginAtZero: true,
            callback: (value: any) => `${value} min`
          },
          scaleLabel: {
            display: true,
            labelString: 'Average Time'
          }
        }]
      }
    }
  });
    }

    private buildVerificationTimeAnalytics(response: any): void {
  this.overallAverageCompletionTime = response?.overallAverageCompletionTime ?? {};

  const shortSeconds = Number(this.overallAverageCompletionTime?.['SHORT FORM']?.averageSeconds ?? 0);
  const fullSeconds = Number(this.overallAverageCompletionTime?.['FULL FORM']?.averageSeconds ?? 0);

  const availableValues = [shortSeconds, fullSeconds].filter(v => v > 0);
  const overallSeconds = availableValues.length
    ? availableValues.reduce((a, b) => a + b, 0) / availableValues.length
    : 0;

  this.overallAvgTimeMinutes = overallSeconds / 60;
  this.overallAvgTimeFormatted = this.formatSeconds(overallSeconds);

  this.buildTopAgentsByAverageTime(response?.agentsStatus ?? []);
  setTimeout(() => this.createVerificationTimeChart(shortSeconds, fullSeconds, overallSeconds));
    }

    private buildTopAgentsByAverageTime(agents: any[]): void {
  this.topAgentsByAvgTime = agents
    .map(agent => {
      const shortSeconds = Number(agent?.averageCompletionTime?.['SHORT FORM']?.averageSeconds ?? 0);
      const fullSeconds = Number(agent?.averageCompletionTime?.['FULL FORM']?.averageSeconds ?? 0);

      const values = [shortSeconds, fullSeconds].filter(v => v > 0);
      const avgSeconds = values.length
        ? values.reduce((a, b) => a + b, 0) / values.length
        : 0;

      return {
        name: `${agent?.firstName ?? ''} ${agent?.lastName ?? ''}`.trim() || '-',
        userName: agent?.userName ?? '-',
        shortFormTime: this.formatSeconds(shortSeconds),
        fullFormTime: this.formatSeconds(fullSeconds),
        avgSeconds,
        avgFormatted: this.formatSeconds(avgSeconds),
        verifiedCount: agent?.verificationStatus?.VERIFIED?.count ?? 0
      };
    })
    .filter(agent => agent.avgSeconds > 0)
    .sort((a, b) => b.avgSeconds - a.avgSeconds)
    .slice(0, 5);
    }

  formatSeconds(seconds: number): string {
    if (!seconds || seconds <= 0) {
      return '0 sec';
    }

    const mins = Math.floor(seconds / 60);
    const secs = Math.round(seconds % 60);

    if (mins > 0 && secs > 0) {
      return `${mins} min ${secs} sec`;
    }

    if (mins > 0) {
      return `${mins} min`;
    }

    return `${secs} sec`;
  }

    formatMinutes(minutes: number): string {
      if (!minutes || minutes <= 0) {
        return '0 min';
      }

      const wholeMinutes = Math.floor(minutes);
      const seconds = Math.round((minutes - wholeMinutes) * 60);

      if (seconds > 0) {
        return `${wholeMinutes} min ${seconds} sec`;
      }

      return `${wholeMinutes} min`;
    }

    getAgentAvgTime(agent: any, formType: 'SHORT FORM' | 'FULL FORM'): string {
      return agent?.averageCompletionTime?.[formType]?.averageFormatted ?? '0 min';
    }

    getShortFormAvgTime(): string {
    return this.overallAverageCompletionTime &&
      this.overallAverageCompletionTime['SHORT FORM']
      ? this.overallAverageCompletionTime['SHORT FORM'].averageFormatted
      : '0 min';
      }

      getFullFormAvgTime(): string {
        return this.overallAverageCompletionTime &&
          this.overallAverageCompletionTime['FULL FORM']
          ? this.overallAverageCompletionTime['FULL FORM'].averageFormatted
          : '0 min';
      }

    changeDate(){
        if (this.isExternalUser) {
          this.loadProviderDashboard();
          return;
        }
        this._fetchHomePageData();
        this.resetExtractionDrilldown();
        this.fetchExtractionMetrics();
    }

    onTimezoneChange() {
    if (this.selectedTimezone) {
      this.sendTimezoneToAPI(this.selectedTimezone);
    }
    if (this.isExternalUser) {
      this.fetchAdminPresence(this.selectedTimezone);
      return;
    }
  }

   sendTimezoneToAPI(timezone: string) {
  const params = { timeZone: timezone };

  this.userService.updateTimezone({}, params).pipe(first()).subscribe({
    next: (response: any) => {
      if (!response) {
        swal.fire({
          title: 'Error!',
          icon: 'error',
          text: response?.message || 'Timezone update failed',
          showConfirmButton: false,
          timer: 5000
        });
        return;
      }

      // Update local state immediately (optional but helpful)
      this.selectedTimezone = timezone;

      // Fire & forget profile refresh (since it returns void)
      this.authService.loadUserProfile();

      // ✅ Use the new timezone directly (no race condition)
      if (this.isExternalUser) {
        this.loadProviderDashboard();
      } else {
        this._fetchHomePageData(timezone);
      }
    },
    error: (error) => {
      swal.fire({
        title: 'Error!',
        icon: 'error',
        text: error?.error?.message || 'Something went wrong',
        showConfirmButton: false,
        timer: 5000
      });
    }
  });
    }

    onProviderPageChange(event: PageEvent): void {
      this.providerPagination.page = event.pageIndex;
      this.providerPagination.size = event.pageSize;

      this.fetchProviderPatients();
    }

    private fetchProviderPatients(): void {
  const requestedPage = this.providerPagination.page;
  const requestedSize = this.providerPagination.size;

  const params: { [key: string]: any } = {
    page: requestedPage + 1,
    size: requestedSize,
    clientId: this.authService.getClientId() || null,
    planType: this.selectedPlanType,
    userTimeZone:
      this.selectedTimezone ||
      this.authService.getTimeZone(),
    duplicate: false,
    isMultipleFilter: true,
    status: true
  };

  if (this.startDate && this.endDate) {
    params.woStartDate =
      this.formatStartOfDay(this.startDate);

    params.woEndDate =
      this.formatEndOfDay(this.endDate);
  }

  Object.keys(params).forEach((key: string) => {
    if (
      params[key] === undefined ||
      params[key] === null ||
      params[key] === ''
    ) {
      delete params[key];
    }
  });

  /*
   * Cancel any older table request.
   * This prevents page 0 from overwriting page 1.
   */
  if (this.providerPatientsSub) {
    this.providerPatientsSub?.unsubscribe();
  }

  this.providerTableLoading = true;

  this.providerPatientsSub = this.patientService
    .getAllPatients(params)
    .pipe(first())
    .subscribe(
      (response: any) => {
        this.providerPatients =
          response?.content || [];

        this.providerTotalRecords =
          response?.totalElements || 0;

        /*
         * Use the page that was requested.
         * The response should match it, but this avoids an
         * unexpected backend value resetting the paginator.
         */
        this.providerPagination.page = requestedPage;
        this.providerPagination.size =
          response?.size !== undefined
            ? response.size
            : requestedSize;

        this.providerTableLoading = false;
        this.cdr.detectChanges();
      },
      error => {
        this.providerPatients = [];
        this.providerTotalRecords = 0;
        this.providerTableLoading = false;
        this.cdr.detectChanges();

        swal.fire({
          title: 'Error!',
          icon: 'error',
          text:
            error?.error?.message ||
            'Unable to load patients.',
          showConfirmButton: false,
          timer: 5000
        });
      }
    );
    }

    get filteredAgentsTableData(): any[] {

    const agents = this.agentsTableData || [];

    const searchTerm = (this.agentSearchTerm || '')
      .trim()
      .toLowerCase();

    if (!searchTerm) {
      return agents;
    }

    return agents.filter((agent: any) => {

      const firstName = (agent?.firstName || '')
        .trim()
        .toLowerCase();

      const lastName = (agent?.lastName || '')
        .trim()
        .toLowerCase();

      const fullName = `${firstName} ${lastName}`.trim();

      return fullName.includes(searchTerm);
    });
  }


  clearAgentSearch(): void {
    this.agentSearchTerm = '';
  }

  openAgentSearch(): void {
    this.showAgentSearch = true;
  }

  closeAgentSearch(): void {
    this.agentSearchTerm = '';
    this.showAgentSearch = false;
  }


}
